// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__149Ap","head":"Table_head__1N_50","col":"Table_col__22Ozv"};